<script setup>
import { useI18n } from "vue-i18n";
const { t, tm } = useI18n();
</script>

<template>
  <div class="apple-pay-wrapper">
    <div class="container">
      <div class="main-content">
        <div class="img-container">
          <img src="../assets/img/phone.png" alt="Apple Pay" />
        </div>
        <div class="list-container">
          <h2>{{ t("new_customer.payWithApplePay.header") }}</h2>
          <div class="list">
            <ul>
              <li
                v-for="(item, i) in tm('new_customer.payWithApplePay.features')"
                :key="`item_${i}`"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr />
      <a :href="t('new_customer.footer.termsAndConditionsLink')" class="btn-termsAndConditions">{{
          t("new_customer.payWithApplePay.button")
        }}</a>
    </div>
  </div>
</template>

<style scoped>
.apple-pay-wrapper {
  background: #c1dade;
}

.container {
  flex-direction: column;
  align-items: center;
  max-width: 1293px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.main-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
  overflow: visible;
  justify-content: center;
}

.img-container {
  max-width: 398px;
  max-height: 732px;
  margin-top: -10%;
}

.img-container img {
  width: 100%;
  height: auto;
}

.list-container {
  display: flex;
  flex-direction: column;
  max-width: 562px;
  margin-top: 20px;
}

.list-container h2 {
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 54px;
  line-height: 54px;
  color: #242e30;
  margin-bottom: 40px;
}

.list ul {
  padding: 0;
  list-style: none;
  margin-left: 40px;
}

.list ul li {
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  color: #242e30;
  position: relative;
  margin-bottom: 40px;
  padding-left: 20px;
}

.list ul li::before {
  height: 28px;
  width: 28px;
  position: absolute;
  left: -42px;
  top: 5px;
  content: "";
  background-position: center;
  background-size: cover;
  background-image: url("../assets/icons/icon-list-blue.svg");
}

hr {
  height: 2px;
  width: 85%;
  border: 2px solid #242e3059;
}

.btn-termsAndConditions {
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 24px;
  font-weight: 900;
  line-height: 30px;
  color: #2a1e13;
  text-decoration: none;
  display: block;
  text-align: center;
  padding: 28px 161px 28px 161px;
  border: 2px solid #242e30;
  border-radius: 15px;
  max-height: 86px;
  max-width: 563px;
  cursor: pointer;
  margin: 30px auto;
}

@media only screen and (max-width: 768px) {
  .main-content {
    flex-direction: column;
    justify-content: center;
    margin-bottom: 40px;
    padding: 18px 40px 26px;
  }

  .list-container h2 {
    font-size: 30px;
    line-height: 27px;
    text-align: center;
    margin-bottom: 20px;
  }
  .img-container {
    margin-top: 5px;
    max-width: 292px;
    max-height: 537px;
  }

  .list-container {
    margin: 0;
    padding: 0;
  }

  .list ul li {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 20px;
  }

  .list ul li::before {
    height: 20px;
    width: 20px;
    left: -32px;
    top: 5px;
  }

  .btn-termsAndConditions {
    padding: 15px 50px 15px 50px;
    max-width: 234px;
    max-height: 53px;
    width: 100%;
    font-size: 16px;
  }
}

@media only screen and (max-width: 922px) {
  .btn-termsAndConditions {
    padding: 15px 50px 15px 50px;
    width: 100%;
  }
}
</style>
